/**
 * Seção "Limites éticos" em modo leitura (Brief 4 · Tela 2 · PR2).
 *
 * Renderiza `ethicalBoundaries.redirectTopics` (chips) + `toneLimits` (lista).
 * Qualquer um pode vir `[]` no serializer real (ex.: persona Jurídico-Regulatório
 * tem `redirectTopics: []`) → "Nenhum definido", espelhando TabGeneralRead.
 */

import { ToneLimitsNote } from './ToneLimitsNote';

import type { PersonaEthicalBoundaries } from '../types';

export function SectionEthicsRead({ ethics }: { ethics: PersonaEthicalBoundaries }): JSX.Element {
  const { redirectTopics, toneLimits } = ethics;

  return (
    <section className="pe-panel">
      <h2 className="pe-panel__title">Limites éticos</h2>
      <p className="pe-panel__subtitle">Tópicos que a IA redireciona e limites de tom.</p>
      <div className="pe-field">
        <span className="pe-field__label">Tópicos de redirecionamento</span>
        {redirectTopics.length > 0 ? (
          <div className="pe-chip-row">
            {redirectTopics.map((topic) => (
              <span key={topic} className="pe-chip">
                {topic}
              </span>
            ))}
          </div>
        ) : (
          <p className="pe-read-value pe-read-value--muted">Nenhum definido</p>
        )}
      </div>
      <div className="pe-field">
        <span className="pe-field__label">Limites de tom</span>
        {toneLimits.length > 0 ? (
          <ul className="pe-read-list">
            {toneLimits.map((limit) => (
              <li key={limit}>{limit}</li>
            ))}
          </ul>
        ) : (
          <p className="pe-read-value pe-read-value--muted">Nenhum definido</p>
        )}
        <ToneLimitsNote />
      </div>
    </section>
  );
}
